import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './ButtonsStyle.css';

export const BackButton = ({ link }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const onClick = () => {
        navigate(link);
    };

    return (
        <button className={'button--main back-button'} onClick={onClick}>
            {t('common:buttons.back')}
        </button>
    );
};